export default __webpack_public_path__ + "static/media/Results-BrainSuite-ButtonLess.ece6e415.svg";